import { PropsWithChildren } from 'react';
import { rgba } from 'polished';
import { Box } from 'reflexbox';
import styled from 'styled-components';

const Container = styled(Box)`
	border: 1px solid ${(props) => props.theme.colors.lightBlue};
	background-color: ${(props) => props.theme.colors.white};
	border-radius: 4px;
	box-shadow: 0 2px 4px ${(props) => rgba(props.theme.colors.lightBlue, 0.5)};
`;

export default function InboxPersonalCard(props: PropsWithChildren<{}>) {
	return <Container>{props.children}</Container>;
}
